<template>
  <side-banner :td_id="td_id.number" :car_id="carid.number" :p_url="p_url.p_url" />
  <confirm-reset />
  <the-title :title="title" />

  <div class="p-configurator" id="color">
    <step-menu />
    <div class="p-configurator__inner color">
      <template v-for="(item, index) in item_list" :key="index">
        <color-body-image
          :class="{ 'is-active': current === index, 'fixed_slider': scrollHeader && current === index }"
          :body_images="item_list[index].slide_image"
          :pri_image="pri_image"
          :current="current"
          :current_angle="current_angle"
          @selected_angle="clickAngle"
        />
        <color-inner-image
          :class="{ 'is-active': current === index }"
          :inner_images="item_list[index].inner_image"
        />
      </template>
      <color-select-image
        :color_images="item_list"
        :selected_color_index="selected_color_index"
        @color_index="clickItem"
      />

      <div class="summary_style">
        <summary-disp :isVisibleCarImage="false" :isChange="isChange" />
      </div>
    </div>
  </div>
  <bottom-banner :td_id="td_id.number" :car_id="carid.number" :p_url="p_url.p_url" />
</template>

<script>
import { props, context, inject, reactive, ref, watch, onMounted } from "vue";
import RjConfiguration from "../functions/RjConfiguration";
import ConfirmReset from "../components/ConfirmReset.vue";
import TheTitle from "../components/Title.vue";
import StepMenu from "../components/StepMenu.vue";
import SummaryDisp from "../components/Summary.vue";
import ColorBodyImage from "../components/ColorBodyImage.vue";
import ColorSelectImage from "../components/ColorSelectImage.vue";
import ColorInnerImage from "../components/ColorInnerImage.vue";
import SideBanner from "../components/SideBanner.vue";
import BottomBanner from "../components/BottomBanner.vue";

export default {
  components: {
    ConfirmReset,
    TheTitle,
    StepMenu,
    SummaryDisp,
    ColorBodyImage,
    ColorSelectImage,
    ColorInnerImage,
    SideBanner,
    BottomBanner,
  },
  setup(props, context) {
    const RJ = RjConfiguration();
    //ブラウザバック時詰め直し
    RJ.getUrlFromPathName();
    const item_list = RJ.getListColor();
    const title = RJ.getTitle();
    const mySelect = RJ.getMySelect();
    const check_code = RJ.getDataColor()["code"];
    const item_car = RJ.getDataCar();
    const query_key = RJ.getMenuActive()["query"];
    let pri_image = ref(undefined);
    let current = ref(0);
    let isChange = reactive({ clort: query_key });
    let td_id = reactive({ number: item_car.testdrive_id });
    let carid = reactive({ number: item_car.catalog_id });
    let p_url = reactive({ p_url: item_car.purchase_url });
    let current_angle = ref(0);
    const selected_color_index = item_list.findIndex(
      ({ code }) => code === check_code
    );


    if (selected_color_index > -1) {
      current.value = selected_color_index;
    }
    // 選択時処理
    const clickItem = (pCode, pIndex) => {
      RJ.selectConfiguration(query_key, pCode, pIndex);
      pri_image.value = 0;
      isChange["color"] = pCode;
      current.value = pIndex;
};

    const clickAngle = (aIndex) => {
      current_angle.value = aIndex;
    };

    const scrollHeader = ref(false);
    function showScrollTop() {
      if (window.matchMedia('(max-width:' + 560 + 'px)').matches) {
        if (window.scrollY >= 391) {
          scrollHeader.value = true;
        } else {
          scrollHeader.value = false;
        }
      }
    }
    onMounted(() => {
      window.addEventListener("scroll", showScrollTop, { passive: true });
    });

    return {
      title,
      pri_image,
      item_list,
      selected_color_index,
      check_code,
      clickItem,
      clickAngle,
      current_angle,
      isChange,
      td_id,
      carid,
      p_url,
      item_car,
      current,
      scrollHeader,
      showScrollTop,
    };
  },
};
</script>

<style lang="scss">
.fixed_slider {
  position: fixed;
  top:0;
  left:0;
  background-color: #fff;
  z-index:500;
  text-align: center;
  padding: 0 0 30px;
  margin: 0;
  .swiper-wrapper {
    margin-bottom: 20px;
  }
}
</style>
